import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, ArrowLeft, ShieldCheck } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { seoPublishedGet } from "@/lib/api";

export default function PublishedPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(undefined);

  useEffect(() => {
    seoPublishedGet(slug).then((p) => {
      setPage(p);
      if (p?.title) document.title = p.title;
    }).catch(() => setPage(null));
    return () => { document.title = "WebsiteTech.pro"; };
  }, [slug]);

  const cleanHtml = (h) => (h || "").replace(/<script[\s\S]*?<\/script>/gi, "");

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="mx-auto max-w-3xl px-4 pb-24 pt-28 sm:px-6" data-testid="published-page">
        {page === undefined && (
          <div className="flex items-center gap-2 text-slate-400"><Loader2 className="animate-spin" size={18} /> Loading…</div>
        )}
        {page === null && (
          <div className="text-center">
            <div className="font-heading text-2xl font-bold text-slate-900">Page not found</div>
            <Link to="/seo" className="mt-4 inline-flex items-center gap-1.5 text-brand"><ArrowLeft size={15} /> Back to SEO Intelligence</Link>
          </div>
        )}
        {page && (
          <>
            <div className="mb-4 inline-flex items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700">
              <ShieldCheck size={13} /> Optimized &amp; published by WebsiteTech
            </div>
            <h1 className="font-heading text-4xl font-extrabold tracking-tight text-slate-900" data-testid="published-title">{page.title}</h1>
            {page.meta_description && <p className="mb-6 mt-3 text-slate-500">{page.meta_description}</p>}
            <article className="prose prose-slate max-w-none" dangerouslySetInnerHTML={{ __html: cleanHtml(page.article_html) }} />
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
